import { get, post } from '../Services/http';

export const getVariantsByRegNo = (variantId, regNo) => {
  return post(`/api/variantpicker/regno`, { variantId, regNo }).then((res) =>
    res.json()
  );
};

export const getVariantsByCarModel = (variantId, carModelVariantSystemId) => {
  return post(`/api/variantpicker/carmodel`, {
    variantId,
    carModelVariantSystemId,
  }).then((res) => res.json());
};

export const getVariantPicker = (variantId) => {
  return get(`/api/variantpicker?variantId=${variantId}`).then((res) =>
    res.json()
  );
};
